import type { ReactNode } from 'react';
import React from 'react';
import type { DialogActionsProps } from '@mui/material';
import { DialogActions } from '@mui/material';

interface CustomDialogActionsProps extends DialogActionsProps {
  children?: ReactNode;
  disableSpacing?: boolean;
}

const CustomDialogActions: React.FC<CustomDialogActionsProps> = ({
  children,
  disableSpacing = false,
  ...props
}) => {
  return (
    <DialogActions disableSpacing={disableSpacing} {...props}>
      {children}
    </DialogActions>
  );
};

export default CustomDialogActions;
